'use client';

import { ReactNode } from 'react';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter';
import { ThemeProvider } from '@mui/material/styles';
import Notifications from '@/core/Notifications';
import GoogleAnalytics from '@/core/GoogleAnalytics';
import theme from '@/components/theme';
import LenisProvider from '@/components/animations/LenisProvider';
import CssBaseline from '@mui/material/CssBaseline';
export default function Providers({
  children,
  analytics = true,
}: {
  children: ReactNode;
  analytics?: boolean;
}) {
  return (
    <AppRouterCacheProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {analytics && <GoogleAnalytics />}

        <LenisProvider>
          <Notifications>{children}</Notifications>
        </LenisProvider>
      </ThemeProvider>
    </AppRouterCacheProvider>
  );
}
